<div class="jumbotron" data-pages="parallax">
  <div class="container-fluid container-fixed-lg sm-p-l-20 sm-p-r-20">
    <div class="inner">
      <ul class="breadcrumb">
        <li><p>Dispatch</p></li>
        <li><a class="active">Dashboard</a></li>
      </ul>
    </div>
  </div>
</div>

<div class="container-fluid container-fixed-lg bg-white">
  <div class="panel panel-transparent">
    <div class="panel-body">
      <!-- Stats Row (always visible) -->
      <div class="row m-b-20">
        <div class="col-md-3 col-sm-6">
          <div
            class="stat-tile"
            [class.tile-active]="activeView === 'driver-notes'"
            (click)="setView('driver-notes')"
          >
            <h2 class="stat-number text-warning">
              <ng-container *ngIf="!driverNotesLoading">{{ openDriverNotesCount }}</ng-container>
              <i *ngIf="driverNotesLoading" class="fa fa-spinner fa-spin"></i>
            </h2>
            <p class="stat-label">Open Driver Notes</p>
            <div class="tile-hint">click to view</div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div
            class="stat-tile"
            [class.tile-active]="activeView === 'accidents'"
            (click)="setView('accidents')"
          >
            <h2 class="stat-number text-danger">
              <ng-container *ngIf="!driverStatusLoading">{{
                driverStatus?.accidentBreakdownCount
              }}</ng-container>
              <i *ngIf="driverStatusLoading" class="fa fa-spinner fa-spin"></i>
            </h2>
            <p class="stat-label">Accidents / Breakdowns</p>
            <div class="tile-hint">click to view</div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div
            class="stat-tile"
            [class.tile-active]="activeView === 'client-notes'"
            (click)="setView('client-notes')"
          >
            <h2 class="stat-number text-info">
              <ng-container *ngIf="!clientNotesLoading">{{ openClientNotesCount }}</ng-container>
              <i *ngIf="clientNotesLoading" class="fa fa-spinner fa-spin"></i>
            </h2>
            <p class="stat-label">Open Client Notes</p>
            <div class="tile-hint">click to view</div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div
            class="stat-tile"
            [class.tile-active]="activeView === 'returning'"
            (click)="setView('returning')"
          >
            <h2 class="stat-number text-success">
              <ng-container *ngIf="!driverStatusLoading">{{
                driverStatus?.returningDriversCount
              }}</ng-container>
              <i *ngIf="driverStatusLoading" class="fa fa-spinner fa-spin"></i>
            </h2>
            <p class="stat-label">Returning Tomorrow</p>
            <div class="tile-hint">click to view</div>
          </div>
        </div>
      </div>

      <!-- ===== VIEW: DRIVER NOTES (full width) ===== -->
      <div *ngIf="activeView === 'driver-notes'">
        <div class="filter-toolbar m-b-10">
          <div class="row filter-row">
            <div class="col-md-2">
              <div class="input-group">
                <span class="input-group-addon"><i class="fa fa-search"></i></span>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Search…"
                  [(ngModel)]="noteSearch"
                  (keyup.enter)="applyDriverNoteFilter()"
                  (blur)="applyDriverNoteFilter()"
                />
              </div>
            </div>
            <div class="col-md-2">
              <select
                class="form-control"
                [(ngModel)]="noteTypeFilter"
                (change)="applyDriverNoteFilter()"
              >
                <option value="">All Types</option>
                <option *ngFor="let t of driverNoteTypes" [value]="t">{{ t }}</option>
              </select>
            </div>
            <div class="col-md-2">
              <select
                class="form-control"
                [(ngModel)]="noteClientFilter"
                (change)="applyDriverNoteFilter()"
              >
                <option value="">All Clients</option>
                <option *ngFor="let c of driverNoteClients" [value]="c">{{ c }}</option>
              </select>
            </div>
            <div class="col-md-2">
              <div class="input-group">
                <span class="input-group-addon">From</span>
                <input
                  type="date"
                  class="form-control"
                  [(ngModel)]="noteDateFrom"
                  (change)="applyDriverNoteFilter()"
                />
              </div>
            </div>
            <div class="col-md-2">
              <div class="input-group">
                <span class="input-group-addon">To</span>
                <input
                  type="date"
                  class="form-control"
                  [(ngModel)]="noteDateTo"
                  (change)="applyDriverNoteFilter()"
                />
              </div>
            </div>
            <div class="col-md-2">
              <div class="filter-actions">
                <label class="filter-include-closed">
                  <input
                    type="checkbox"
                    [(ngModel)]="driverNotesIncludeClosed"
                    (change)="onIncludeClosedChange()"
                  />
                  Closed
                </label>
                <button
                  class="btn btn-default btn-sm"
                  (click)="clearDriverNoteFilters()"
                  title="Clear filters"
                >
                  <i class="fa fa-times"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="panel panel-default">
          <div class="panel-body p-0">
            <div *ngIf="driverNotesLoading" class="text-center p-t-20 p-b-20">
              <i class="fa fa-spinner fa-spin"></i> Loading...
            </div>
            <div *ngIf="!driverNotesLoading" class="table-responsive">
              <table class="table table-hover table-condensed notes-table m-b-0">
                <thead>
                  <tr>
                    <th
                      style="width: 9%"
                      class="sortable-header"
                      (click)="sortDriverNotes('dateCreatedUtc')"
                    >
                      Date <i [ngClass]="getSortIcon('dateCreatedUtc')"></i>
                    </th>
                    <th
                      style="width: 17%"
                      class="sortable-header"
                      (click)="sortDriverNotes('driverName')"
                    >
                      Driver <i [ngClass]="getSortIcon('driverName')"></i>
                    </th>
                    <th
                      style="width: 16%"
                      class="sortable-header"
                      (click)="sortDriverNotes('type')"
                    >
                      Type <i [ngClass]="getSortIcon('type')"></i>
                    </th>
                    <th
                      style="width: 17%"
                      class="sortable-header"
                      (click)="sortDriverNotes('clientName')"
                    >
                      Client <i [ngClass]="getSortIcon('clientName')"></i>
                    </th>
                    <th>Note</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    *ngFor="let note of filteredDriverNotes"
                    class="note-row-clickable"
                    [class.row-breakdown]="getNoteTypeClass(note.type) === 'type-breakdown'"
                    [class.row-followup-today]="isFollowUpToday(note.followUpDate)"
                    [class.row-closed]="note.status === 'Resolved'"
                    (dblclick)="viewDriverNote(note)"
                  >
                    <td
                      class="text-nowrap"
                      [title]="note.dateCreatedUtc | date: 'MM/dd/yyyy h:mm a'"
                    >
                      {{ note.dateCreatedUtc | date: "MM/dd/yy" }}
                    </td>
                    <td>
                      <app-driver-card
                        *ngIf="note.driverId && driverCardCache[note.driverId]"
                        [driver]="driverCardCache[note.driverId]"
                        tooltipPosition="right"
                      >
                        <a
                          [routerLink]="['/drivers', note.driverId]"
                          (click)="$event.stopPropagation()"
                          ><i class="fa fa-external-link"></i> {{ note.driverName }}</a
                        >
                      </app-driver-card>
                      <ng-container *ngIf="!note.driverId || !driverCardCache[note.driverId]">
                        <a
                          *ngIf="note.driverId"
                          [routerLink]="['/drivers', note.driverId]"
                          (click)="$event.stopPropagation()"
                          ><i class="fa fa-external-link"></i> {{ note.driverName }}</a
                        >
                        <span *ngIf="!note.driverId">{{ note.driverName }}</span>
                      </ng-container>
                    </td>
                    <td>
                      <span class="type-badge" [ngClass]="getNoteTypeClass(note.type)">{{
                        note.type
                      }}</span>
                      <span *ngIf="note.status === 'Resolved'" class="closed-badge">Closed</span>
                    </td>
                    <td>{{ note.clientName }}</td>
                    <td>
                      <div class="note-cell">
                        <span class="note-preview-text note-preview-wide" [title]="note.note">{{
                          note.note
                        }}</span>
                        <div class="note-meta">
                          <span *ngIf="note.tripNumber" class="note-meta-chip"
                            ><i class="fa fa-truck"></i> Trip #{{ note.tripNumber }}</span
                          >
                          <span *ngIf="note.customerReferenceNumber" class="note-meta-chip"
                            ><i class="fa fa-tag"></i> Ref: {{ note.customerReferenceNumber }}</span
                          >
                          <span
                            *ngIf="note.followUpDate"
                            class="note-followup-badge"
                            [class.overdue]="
                              isFollowUpOverdue(note.followUpDate) && note.status !== 'Resolved'
                            "
                            [title]="'Follow up: ' + (note.followUpDate | date: 'MM/dd/yy')"
                          >
                            <i class="fa fa-calendar-o"></i>
                            <ng-container
                              *ngIf="
                                isFollowUpOverdue(note.followUpDate) && note.status !== 'Resolved'
                              "
                              >Overdue</ng-container
                            >
                            <ng-container
                              *ngIf="
                                !isFollowUpOverdue(note.followUpDate) || note.status === 'Resolved'
                              "
                              >{{ note.followUpDate | date: "MM/dd/yy" }}</ng-container
                            >
                          </span>
                          <span
                            *ngIf="note.createdByUserName"
                            class="note-meta-chip note-meta-chip-muted"
                            ><i class="fa fa-user-o"></i> {{ note.createdByUserName }}</span
                          >
                          <span
                            *ngIf="note.emailedToSafety"
                            class="note-meta-chip note-meta-chip-email"
                            [title]="
                              'Emailed to Safety: ' +
                              (note.emailedToSafety | date: 'MM/dd/yy HH:mm')
                            "
                            ><i class="fa fa-envelope-o"></i> Safety</span
                          >
                          <span
                            *ngIf="note.emailedFormToDriver"
                            class="note-meta-chip note-meta-chip-email"
                            [title]="
                              'Form Emailed to Driver: ' +
                              (note.emailedFormToDriver | date: 'MM/dd/yy HH:mm')
                            "
                            ><i class="fa fa-envelope-o"></i> Form→Driver</span
                          >
                          <span
                            *ngIf="note.emailedToClient"
                            class="note-meta-chip note-meta-chip-email"
                            [title]="
                              'Emailed to Client: ' +
                              (note.emailedToClient | date: 'MM/dd/yy HH:mm')
                            "
                            ><i class="fa fa-envelope-o"></i> Client</span
                          >
                          <span
                            *ngIf="note.emailedToDriver"
                            class="note-meta-chip note-meta-chip-email"
                            [title]="
                              'Emailed to Driver: ' +
                              (note.emailedToDriver | date: 'MM/dd/yy HH:mm')
                            "
                            ><i class="fa fa-envelope-o"></i> Driver</span
                          >
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr *ngIf="filteredDriverNotes.length === 0">
                    <td colspan="6" class="empty-tab-state">
                      <i class="fa fa-search"></i> No notes found
                    </td>
                  </tr>
                </tbody>
              </table>
              <p-paginator
                [rows]="driverNotesPageSize"
                [first]="driverNotesPage * driverNotesPageSize"
                [totalRecords]="driverNotesTotalCount"
                (onPageChange)="onDriverNotesPageChange($event)"
              ></p-paginator>
            </div>
          </div>
        </div>
      </div>
      <!-- END VIEW: DRIVER NOTES -->

      <!-- ===== VIEW: ACCIDENTS / BREAKDOWNS ===== -->
      <div *ngIf="activeView === 'accidents'">
        <div class="filter-toolbar m-b-10">
          <div class="row filter-row">
            <div class="col-md-3">
              <div class="input-group">
                <span class="input-group-addon"><i class="fa fa-search"></i></span>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Search&hellip;"
                  [(ngModel)]="accidentSearch"
                  (keyup.enter)="applyAccidentFilter()"
                  (blur)="applyAccidentFilter()"
                />
              </div>
            </div>
            <div class="col-md-2">
              <select
                class="form-control"
                [(ngModel)]="accidentTypeFilter"
                (change)="applyAccidentFilter()"
              >
                <option value="">All Types</option>
                <option *ngFor="let t of accidentItemTypes" [value]="t">{{ t }}</option>
              </select>
            </div>
            <div class="col-md-3">
              <div class="input-group">
                <span class="input-group-addon">From</span>
                <input
                  type="date"
                  class="form-control"
                  [(ngModel)]="accidentDateFrom"
                  (change)="applyAccidentFilter()"
                />
              </div>
            </div>
            <div class="col-md-3">
              <div class="input-group">
                <span class="input-group-addon">To</span>
                <input
                  type="date"
                  class="form-control"
                  [(ngModel)]="accidentDateTo"
                  (change)="applyAccidentFilter()"
                />
              </div>
            </div>
            <div class="col-md-1">
              <div class="filter-actions">
                <label class="filter-include-closed">
                  <input
                    type="checkbox"
                    [(ngModel)]="accidentIncludeClosed"
                    (change)="onAccidentIncludeClosedChange()"
                  />
                  Closed
                </label>
                <button
                  class="btn btn-default btn-sm"
                  (click)="clearAccidentFilters()"
                  title="Clear filters"
                >
                  <i class="fa fa-times"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="accidentBreakdownsLoading" class="text-center p-t-20 p-b-20">
          <i class="fa fa-spinner fa-spin"></i> Loading...
        </div>
        <div *ngIf="!accidentBreakdownsLoading">
          <div class="panel panel-default">
            <div class="panel-body p-0">
              <div *ngIf="accidentTotalCount === 0" class="empty-tab-state" style="padding: 40px 0">
                <i class="fa fa-check-circle-o"></i> No open accidents or breakdowns
              </div>
              <div *ngIf="accidentBreakdowns.length > 0" class="table-responsive">
                <table class="table table-hover table-condensed notes-table m-b-0">
                  <thead>
                    <tr>
                      <th style="width: 12%">Date</th>
                      <th style="width: 18%">Driver</th>
                      <th style="width: 10%">Type</th>
                      <th style="width: 26%">Location</th>
                      <th style="width: 12%">Tractor / Trailer</th>
                      <th>Flags</th>
                      <th>Emails</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      *ngFor="let item of accidentBreakdowns"
                      class="note-row-clickable"
                      [class.row-breakdown]="!isAccidentType(item)"
                      [class.row-closed]="item.status === 'Resolved'"
                      (dblclick)="viewDriverNote(item)"
                    >
                      <td class="text-nowrap">
                        <ng-container *ngIf="isAccidentType(item)">
                          <span [title]="item.dateCreatedUtc | date: 'MM/dd/yyyy h:mm a'">
                            {{ item.accidentDate | date: "MM/dd/yy" }}
                          </span>
                        </ng-container>
                        <ng-container *ngIf="!isAccidentType(item)">
                          {{ item.dateCreatedUtc | date: "MM/dd/yy" }}
                        </ng-container>
                      </td>
                      <td>
                        <app-driver-card
                          *ngIf="item.driverId && driverCardCache[item.driverId]"
                          [driver]="driverCardCache[item.driverId]"
                          tooltipPosition="right"
                        >
                          <a
                            [routerLink]="['/drivers', item.driverId]"
                            (click)="$event.stopPropagation()"
                            ><i class="fa fa-external-link"></i> {{ item.driverName }}</a
                          >
                        </app-driver-card>
                        <ng-container *ngIf="!item.driverId || !driverCardCache[item.driverId]">
                          <a
                            *ngIf="item.driverId"
                            [routerLink]="['/drivers', item.driverId]"
                            (click)="$event.stopPropagation()"
                            ><i class="fa fa-external-link"></i> {{ item.driverName }}</a
                          >
                          <span *ngIf="!item.driverId">{{ item.driverName }}</span>
                        </ng-container>
                      </td>
                      <td>
                        <span class="type-badge" [ngClass]="getNoteTypeClass(item.type)">{{
                          item.type === "Breakdown & follow up" ? "Breakdown" : item.type
                        }}</span>
                      </td>
                      <td>
                        <ng-container *ngIf="isAccidentType(item)">
                          <span>{{
                            joinAccidentLocation(
                              item.accidentCity,
                              item.accidentState,
                              item.accidentLocation
                            ) || "—"
                          }}</span>
                        </ng-container>
                        <ng-container *ngIf="!isAccidentType(item)">
                          <ng-container *ngIf="item.type === 'Delay'; else breakdownIssue">
                            <span *ngIf="item.clientNotes" [title]="item.clientNotes">{{
                              item.clientNotes
                            }}</span>
                            <span *ngIf="!item.clientNotes" class="text-muted">—</span>
                          </ng-container>
                          <ng-template #breakdownIssue>
                            <span *ngIf="item.truckTrailerIssue">{{ item.truckTrailerIssue }}</span>
                            <span *ngIf="!item.truckTrailerIssue">—</span>
                          </ng-template>
                          <span *ngIf="item.eta" class="note-meta-chip m-l-5"
                            >ETA: {{ item.eta }}</span
                          >
                        </ng-container>
                      </td>
                      <td class="text-nowrap">
                        {{ item.tractorNumber || "—" }} / {{ item.trailerNumber || "—" }}
                      </td>
                      <td>
                        <ng-container *ngIf="isAccidentType(item)">
                          <span *ngIf="item.anyInjuries" class="type-badge type-breakdown m-r-5">
                            <i class="fa fa-exclamation-circle text-danger"></i> Injuries
                          </span>
                          <span *ngIf="item.driverCitation" class="type-badge type-breakdown">
                            <i class="fa fa-exclamation-circle text-danger"></i> Citation
                          </span>
                          <span
                            *ngIf="
                              !item.anyInjuries &&
                              !item.anotherVehicleInvolved &&
                              !item.driverCitation
                            "
                            class="text-muted"
                            >—</span
                          >
                        </ng-container>
                        <ng-container *ngIf="!isAccidentType(item)">
                          <span *ngIf="item.roadCallNumber" class="note-meta-chip"
                            >RC# {{ item.roadCallNumber }}</span
                          >
                          <span *ngIf="!item.roadCallNumber" class="text-muted">—</span>
                        </ng-container>
                      </td>
                      <td>
                        <div class="note-meta">
                          <span
                            *ngIf="item.emailedToSafety"
                            class="note-meta-chip note-meta-chip-email"
                            [title]="
                              'Emailed to Safety: ' +
                              (item.emailedToSafety | date: 'MM/dd/yy HH:mm')
                            "
                            ><i class="fa fa-envelope-o"></i> Safety</span
                          >
                          <span
                            *ngIf="item.emailedFormToDriver"
                            class="note-meta-chip note-meta-chip-email"
                            [title]="
                              'Form Emailed to Driver: ' +
                              (item.emailedFormToDriver | date: 'MM/dd/yy HH:mm')
                            "
                            ><i class="fa fa-envelope-o"></i> Form→Driver</span
                          >
                          <span
                            *ngIf="item.emailedToClient"
                            class="note-meta-chip note-meta-chip-email"
                            [title]="
                              'Emailed to Client: ' +
                              (item.emailedToClient | date: 'MM/dd/yy HH:mm')
                            "
                            ><i class="fa fa-envelope-o"></i> Client</span
                          >
                          <span
                            *ngIf="item.emailedToDriver"
                            class="note-meta-chip note-meta-chip-email"
                            [title]="
                              'Emailed to Driver: ' +
                              (item.emailedToDriver | date: 'MM/dd/yy HH:mm')
                            "
                            ><i class="fa fa-envelope-o"></i> Driver</span
                          >
                          <span
                            *ngIf="
                              !item.emailedToSafety &&
                              !item.emailedFormToDriver &&
                              !item.emailedToClient &&
                              !item.emailedToDriver
                            "
                            class="text-muted"
                            >—</span
                          >
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <p-paginator
            [rows]="accidentPageSize"
            [first]="accidentPage * accidentPageSize"
            [totalRecords]="accidentTotalCount"
            (onPageChange)="onAccidentPageChange($event)"
          ></p-paginator>
        </div>
      </div>
      <!-- END VIEW: ACCIDENTS / BREAKDOWNS -->

      <!-- ===== VIEW: CLIENT NOTES (full width) ===== -->
      <div *ngIf="activeView === 'client-notes'">
        <div class="filter-toolbar m-b-10">
          <div class="row filter-row">
            <div class="col-md-2">
              <div class="input-group">
                <span class="input-group-addon"><i class="fa fa-search"></i></span>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Search&hellip;"
                  [(ngModel)]="clientNoteSearch"
                  (keyup.enter)="applyClientNoteFilter()"
                  (blur)="applyClientNoteFilter()"
                />
              </div>
            </div>
            <div class="col-md-2">
              <select
                class="form-control"
                [(ngModel)]="clientNoteTypeFilter"
                (change)="applyClientNoteFilter()"
              >
                <option value="">All Types</option>
                <option *ngFor="let t of clientNoteTypes" [value]="t">{{ t }}</option>
              </select>
            </div>
            <div class="col-md-2">
              <select
                class="form-control"
                [(ngModel)]="clientNoteClientFilter"
                (change)="applyClientNoteFilter()"
              >
                <option value="">All Clients</option>
                <option *ngFor="let c of clientNoteClients" [value]="c">{{ c }}</option>
              </select>
            </div>
            <div class="col-md-2">
              <div class="input-group">
                <span class="input-group-addon">From</span>
                <input
                  type="date"
                  class="form-control"
                  [(ngModel)]="clientNoteDateFrom"
                  (change)="applyClientNoteFilter()"
                />
              </div>
            </div>
            <div class="col-md-2">
              <div class="input-group">
                <span class="input-group-addon">To</span>
                <input
                  type="date"
                  class="form-control"
                  [(ngModel)]="clientNoteDateTo"
                  (change)="applyClientNoteFilter()"
                />
              </div>
            </div>
            <div class="col-md-2">
              <div class="filter-actions">
                <label class="filter-include-closed">
                  <input
                    type="checkbox"
                    [(ngModel)]="clientNoteIncludeClosed"
                    (change)="onClientNoteIncludeClosedChange()"
                  />
                  Closed
                </label>
                <button
                  class="btn btn-default btn-sm"
                  (click)="clearClientNoteFilters()"
                  title="Clear filters"
                >
                  <i class="fa fa-times"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="panel panel-default">
          <div class="panel-body p-0">
            <div *ngIf="clientNotesLoading" class="text-center p-t-20 p-b-20">
              <i class="fa fa-spinner fa-spin"></i> Loading...
            </div>
            <div *ngIf="!clientNotesLoading" class="table-responsive">
              <table class="table table-hover table-condensed notes-table m-b-0">
                <thead>
                  <tr>
                    <th style="width: 9%">Date</th>
                    <th style="width: 22%">Client</th>
                    <th style="width: 16%">Type</th>
                    <th>Note</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    *ngFor="let note of openClientNotes"
                    class="note-row-clickable"
                    [class.row-breakdown]="getNoteTypeClass(note.type) === 'type-breakdown'"
                    [class.row-followup-today]="isFollowUpToday(note.followUpDate)"
                    [class.row-closed]="note.status === 'Resolved'"
                    (dblclick)="viewClientNote(note)"
                  >
                    <td class="text-nowrap">{{ note.dateCreatedUtc | date: "MM/dd/yy" }}</td>
                    <td>{{ note.clientName }}</td>
                    <td>
                      <span class="type-badge" [ngClass]="getNoteTypeClass(note.type)">{{
                        note.type
                      }}</span>
                      <span *ngIf="note.status === 'Resolved'" class="closed-badge">Closed</span>
                    </td>
                    <td>
                      <div class="note-cell">
                        <span class="note-preview-text note-preview-wide" [title]="note.note">{{
                          note.note
                        }}</span>
                        <div class="note-meta" *ngIf="note.createdByUserName">
                          <span
                            class="note-meta-chip note-meta-chip-muted"
                            *ngIf="note.createdByUserName"
                            ><i class="fa fa-user-o"></i> {{ note.createdByUserName }}</span
                          >
                        </div>
                      </div>
                    </td>
                  </tr>
                  <tr *ngIf="openClientNotes.length === 0">
                    <td colspan="5" class="empty-tab-state">
                      <i class="fa fa-search"></i> No notes match your filters
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p-paginator
              [rows]="clientNotesPageSize"
              [first]="clientNotesPage * clientNotesPageSize"
              [totalRecords]="clientNotesTotalCount"
              (onPageChange)="onClientNotePageChange($event)"
            ></p-paginator>
          </div>
        </div>
      </div>
      <!-- END VIEW: CLIENT NOTES -->

      <!-- ===== VIEW: RETURNING DRIVERS ===== -->
      <div *ngIf="activeView === 'returning'">
        <div *ngIf="driverStatusLoading" class="text-center p-t-20 p-b-20">
          <i class="fa fa-spinner fa-spin"></i> Loading...
        </div>
        <div *ngIf="!driverStatusLoading && driverStatus">
          <div
            *ngIf="driverStatus.returningDriversCount === 0"
            class="empty-tab-state"
            style="padding: 40px 0"
          >
            <i class="fa fa-calendar-o"></i> No drivers returning tomorrow
          </div>
          <div class="driver-grid">
            <a
              *ngFor="let driver of driverStatus.returningDrivers"
              [routerLink]="['/drivers', driver.id]"
              class="driver-grid-card returning-card"
            >
              <div class="driver-grid-photo">
                <img [src]="getDriverPictureUrl(driver)" [alt]="driver.name" />
              </div>
              <div class="driver-grid-name">{{ driver.name }}</div>
            </a>
          </div>
        </div>
      </div>
      <!-- END VIEW: RETURNING DRIVERS -->
    </div>
  </div>
</div>

<!-- Driver Note View Modal -->
<app-driver-note-form-modal
  *ngIf="selectedDriverNote"
  [(visible)]="driverNoteModalVisible"
  [note]="selectedDriverNote"
  [readOnly]="!canEditDriverNotes"
  [hideEmailButtons]="!canEditDriverNotes"
  (saved)="onDriverNoteSaved($event)"
  (closed)="onDriverNoteModalClosed()"
></app-driver-note-form-modal>

<!-- Client Note View Modal -->
<app-client-note-view-modal
  *ngIf="selectedClientNote"
  [(visible)]="clientNoteModalVisible"
  [note]="selectedClientNote"
  [canEdit]="canEditClientNotes"
  (closed)="onClientNoteModalClosed()"
  (noteSaved)="onClientNoteSaved($event)"
></app-client-note-view-modal>
